import type { JSX } from "react";

import { Loading } from "@/components/Loading";
import { SignIn } from "@/components/SignIn";
import { useConvexAuth } from "convex/react";

interface AuthGuardProps {
  children: JSX.Element;
}

export const AuthGuard = ({ children }: AuthGuardProps) => {
  const { isLoading, isAuthenticated } = useConvexAuth();

  if (!isAuthenticated && !isLoading) {
    return <SignIn />;
  }

  if (isLoading) {
    // Show loading state while authentication is in progress
    return <Loading />;
  }

  return children;
};
